import React, { useState, useEffect } from "react";
import { useLocation, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import queryString from "query-string";
import { IS_LOCAL } from "configs/utils";

// Components
import StickyNavbar from "components/StickyNavbar/StickyNavbar";
import FooterNew from "components/FooterNew/FooterNew";
import DietMadeEasy from "components/DietMadeEasy/DietMadeEasy";
import SectionWrapper from "components/General/sectionWrapper/SectionWrapper";
import StandardProgram from "components/StandardProgram/StandardProgram";
import NutritionCoach from "components/NutritionCoach/NutritionCoach";
import YoyoEffect from "components/YoyoEffect/YoyoEffect";
import CoachFromFoodiary from "components/CoachFromFoodiary/CoachFromFoodiary";
import BenefitsGlance from "components/BenefitsGlance/BenefitsGlance";
import StartNutritionChange from "components/StartNutritionChange/StartNutritionChange";
import StartTogether from "components/StartTogether/StartTogether";
import TestimonialSlider from "components/TestimonialSlider/TestimonialSlider";
import PaymentModal from "modals/PaymentModal/PaymentModal";
import FailureDialog from "modals/FailureDialog";
// Redux
import * as CoachActions from "redux/coach/coach.actions";
import * as Routes from "routes/routes";
// Styles
import * as C from "./coachingPro.styles";
import * as G from "styles/General.Styles";
import InitialConsultationBox from "components/InitialConsultationBox/InitialConsultationBox";
import hook from "assets/images/hook.svg";
import WhyClientsLoveUs from "components/WhyClientsLoveUs/WhyClientsLoveUs";
import TogetherWithMe from "components/TogetherWithMe/TogetherWithMe";
import CoachingGlance from "components/CoachingGlance/CoachingGlance";
import ReimburseHealthInsurance from "components/ReimburseHealthInsurance/ReimburseHealthInsurance";
import CoachingProFeatures from "components/CoachingProFeatures/CoachingProFeatures";
import LastingSuccessWithKnowledge from "components/LastingSuccessWithKnowledge/LastingSuccessWithKnowledge";
import LeadSurveyModal from "modals/LeadSurveyModal/LeadSurveyModal";
import HealthInsuranceCompanies from "components/HealthInsuranceCompanies/HealthInsuranceCompanies";
import HollisticSupport from "components/HolisticSupport/HollisticSupport";
import KnowEachOther from "components/KnowEachOther/KnowEachOther";
import CoachingHealthCompanies from "components/CoachingHealthCompanies/CoachingHealthCompanies";
import ScollDown from "assets/images/scroll-down.svg";

const CoachingPro = (props) => {
  const [openPaymentModal, setOpenPaymentModal] = useState(false);
  const [successDialog, setSuccessDialog] = useState(false);
  const [cancelDialog, setCancelDialog] = useState(false);
  const [openLeadModal, setOpenLeadModal] = useState(false);

  const coach = useSelector((state) => state.coach.coach);

  const dispatch = useDispatch();
  const history = useHistory();
  const { search } = useLocation();

  useEffect(() => {
    const { success } = queryString.parse(search);
    if (success == "true") {
      setSuccessDialog(true);
      history.push(Routes.SUCCESS);
    }
    if (success == "false") {
      setCancelDialog(true);
    }
  }, [search]);

  useEffect(() => {
    window.scrollTo(0, 0);

    if (coach) return;

    const coach_website_url = IS_LOCAL
      ? "https://ronja-fci49818.foodiary.app" ||
        "https://sebastian-fci1.foodiary.app"
      : `${window.location.protocol}//${window.location.host}`;

    dispatch(
      CoachActions.trainerIdRequest({
        formData: { coach_website_url },
        callback: (res) => {
          dispatch(
            CoachActions.coachDataRequest({
              formData: { trainerID: res?.trainerID },
              callback: () => null,
            })
          );
        },
      })
    );
  }, [dispatch, coach]);

  return (
    <>
      <C.Header>
        <C.HeaderInner>
          <G.ContainerNavbar>
            <StickyNavbar
              openSurveyModal={() => setOpenLeadModal(!openLeadModal)}
            />
          </G.ContainerNavbar>
          <G.Container>
            <C.HeaderContentWrapper>
              <C.HeaderContent>
                <C.Chip className="font-medium">COACHING PRO</C.Chip>
                <C.HeaderTitle className="ct-text-block font-bold color-dark text-center mt-8 text-5xl">
                  Mein persönliches <br /> Coaching
                </C.HeaderTitle>
                <C.HeaderDescription className="ct-text-block color-paragraph text-base text-center">
                  Als dein persönlicher Ernährungsberater unterstütze ich dich
                  in 3 Monaten
                  <br />
                  deine Ernährung nachhaltig, gesund und langfristig
                  umzustellen.
                </C.HeaderDescription>
              </C.HeaderContent>
              <div className="hook-block">
                <img width="100" src={ScollDown} alt="hook" />
              </div>
            </C.HeaderContentWrapper>
          </G.Container>
        </C.HeaderInner>
      </C.Header>

      <G.Container>
        <SectionWrapper margin="15rem 0 0" mobileMargin="7rem 0 0">
          <TogetherWithMe onLeadFormModal={() => setOpenLeadModal(true)} />
        </SectionWrapper>

        <SectionWrapper margin="15rem 0" mobileMargin="10rem 0 0">
          <HollisticSupport onLeadFormModal={() => setOpenLeadModal(true)} />
        </SectionWrapper>

        <SectionWrapper margin="15rem 0 0" mobileMargin="10rem 0 0">
          <CoachingProFeatures />
        </SectionWrapper>

        <SectionWrapper margin="15rem 0 0" mobileMargin="10rem 0 0">
          <KnowEachOther onLeadFormModal={() => setOpenLeadModal(true)} />
        </SectionWrapper>

        <SectionWrapper margin="15rem 0 0" mobileMargin="10rem 0 0">
          <WhyClientsLoveUs />
        </SectionWrapper>
      </G.Container>
      <SectionWrapper margin="15rem 0 0" mobileMargin="7rem 0 0">
        <CoachingHealthCompanies title={"100% CASHBACK VON DER KRANKENKASSE"} />
      </SectionWrapper>
      <G.Container>
        <SectionWrapper margin="15rem 0 0" mobileMargin="7rem 0 0">
          <CoachingGlance
            onPaymentModal={() => setOpenPaymentModal(true)}
            onLeadFormModal={() => setOpenLeadModal(true)}
          />
        </SectionWrapper>

        {/* <SectionWrapper margin="20rem 0 0" mobileMargin="5rem 0 0">
          <YoyoEffect />
        </SectionWrapper> */}

        {/* <SectionWrapper margin="20rem 0 0" mobileMargin="5rem 0 0">
          <LastingSuccessWithKnowledge />
        </SectionWrapper> */}

        {/* <SectionWrapper margin="20rem 0 0" mobileMargin="5rem 0 0">
          <DietMadeEasy onPaymentModal={() => setOpenPaymentModal(true)} />
        </SectionWrapper> */}

        {/* <SectionWrapper margin="20rem 0 0" mobileMargin="5rem 0 0">
          <ReimburseHealthInsurance
            onLeadFormModal={() => setOpenLeadModal(true)}
            changeOrder
          />
        </SectionWrapper> */}

        <PaymentModal
          isOpen={openPaymentModal}
          onClose={() => setOpenPaymentModal(false)}
          couchProfile={coach}
        />
        <FailureDialog
          open={cancelDialog}
          close={() => setCancelDialog(false)}
        />
      </G.Container>

      <SectionWrapper margin="15rem 0 0" mobileMargin="10rem 0 0">
        <InitialConsultationBox
          openLeadFormModal={() => setOpenLeadModal(true)}
        />
      </SectionWrapper>

      <FooterNew />

      {coach && (
        <LeadSurveyModal
          isOpen={openLeadModal}
          onClose={() => setOpenLeadModal(false)}
          coachProfile={coach}
        />
      )}
    </>
  );
};

export default CoachingPro;
